<template>
  <div class="text-sm text-muted-foreground font-regular leading-[150%]">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>
